__turbopack_context__.v({
  "coloredText": "RichSegments-module__HA-Vuq__coloredText",
  "link": "RichSegments-module__HA-Vuq__link",
});
